import React, {useEffect, useState} from 'react'
import FailedModal from "../../../CustomModal/Failed";
import Loader from "../../../../Loader/Loader";
import DashboardMenu from "../../../layout/dashboardMenu";
import Header from "../../../layout/header";
import useLatLng from "../../../../hooks/uselatlng/uselatlng";
import {toast} from "react-toastify";
import Moment from 'moment';
import DropDownInput from "../../../Input/dropDownInput/dropDownInput";
import SuccessModal from "../../../CustomModal/Success";
import FileUpload from "../../../FileUploads/FileUpload";

const ValetActivitySave = ({
                          documentUploadUrlPublic,
                          saveActivity,
                          documentUrlDataPublic=[],
                          history,
                          match,
                          getPendingActivity,
                          saveActivityRes = [],
                          activityTypesDetails = [],
                          activityTypes,
                          getSenior,
                          senior=[],
                          pendingActivity=[]
                      }) => {

    var now = new Date();
    now.setMinutes(now.getMinutes() - now.getTimezoneOffset());
    const islatlng = useLatLng();
    const [isLoading, setIsLoading] = useState(false)
    const [isFailedModalOpen, setIsFailedModalOpen] = useState(false);
    const [countToOpenModal, setCountToOpenModal] = useState(0)
    const [inputList, setInputList] = useState([{
        activity_type_id: '',
        activity_date: '',
        meta_data: {},
        lat: '',
        long: '',
        next_activity_type_id: '',
        next_activity_date: '',
        description: '',
        tagged_along:''
    }])
    const [isActivityCreated, setIsActivityCreated] = useState(false)
    const [activityTypeId, setActivityTypeId] = useState('')
    const [distance, setDistance] = useState(0)
    const [currentDate, setCurrentDate] = useState(now.toISOString().slice(0, 16))
    const [taggedAlonedReportee, setTaggedAlonedReportee] = useState({})
    const [isSuccessModalOpen, setIsSuccessModalOpen] = React.useState(false);

    useEffect(() => {
        (async () => {
            setIsLoading(true)
            await getPendingActivity(match?.params?.account_id !== undefined ? match?.params?.account_id : "")
            await activityTypes('is_valet', 1)
            await getSenior()
            setIsLoading(false)
        })()
    }, [])

    const toRad = (Value) => {
        return Value * Math.PI / 180
    }

    const calcCrow = (lat1, lon1, lat2, lon2) => {
        var R = 6371 // km
        var dLat = toRad(lat2 - lat1)
        var dLon = toRad(lon2 - lon1)
        var lat1 = toRad(lat1)
        var lat2 = toRad(lat2)

        var a = Math.sin(dLat / 2) * Math.sin(dLat / 2) +
            Math.sin(dLon / 2) * Math.sin(dLon / 2) * Math.cos(lat1) * Math.cos(lat2)
        var c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a))
        var d = R * c
        return d
    }

    const handleInput = (key, val, metaKey, e) => {
        let list = [...inputList]
        if (key === 'meta_data') {
            if (e.target !== undefined && e.target.selectedOptions !== undefined) {
                let desc = e.target.selectedOptions[0].text;
                inputList[0][key][metaKey] = desc
                inputList[0][key][metaKey + "_id"] = val
            } else {
                inputList[0][key][metaKey] = val
            }
        } else {
            inputList[0][key] = val
        }
        setInputList(list)
    }

    useEffect(() => {
        setIsFailedModalOpen(false)
        setIsSuccessModalOpen(false)
        if (saveActivityRes?.status === 200) {
            setIsSuccessModalOpen(true)
            // window.location.href = `dealer-activity-list/${match?.params?.module_id}`
        } else if (saveActivityRes?.status !== undefined && saveActivityRes?.status !== 200) {
            setCountToOpenModal(countToOpenModal + 1)
            setIsFailedModalOpen(true)
        }
    }, [saveActivityRes])

    useEffect(() => {
        let values = ""
        let names = []
        if (taggedAlonedReportee !== [] && taggedAlonedReportee !== '' && taggedAlonedReportee.length > 0) {
            taggedAlonedReportee.map((val, i) => {
                names[i] = val?.name
                if (i === 0) {
                    values = val.id
                } else {
                    values += ',' + val.id
                }
            })
        }
        handleInput('tagged_along', values, '', '');
    }, [taggedAlonedReportee])

    const handleSubmit = async (e) => {
        e.preventDefault()
        let list = inputList[0]
        if (list['next_activity_type_id'] === '') {
            toast.error("Please choose activity type")
            return false
        }
        list['next_activity_date'] = currentDate
        if (list['next_activity_date'] === '') {
            toast.error("Please choose next activity date")
            return false
        }

        list['account_id'] = match?.params?.account_id
        list['opportunity_id'] = match?.params?.opportunity_id
        list['lat'] = islatlng?.lat
        list['long'] = islatlng?.lng
        if (list['long'] == null || list['lat'] == null) {
            toast.error('Please enable your location');
            return false
        }

        if (isActivityCreated && list['next_activity_type_id'] !== '') {
            toast.error("Please complete your pending activity before creating new one.")
            return false
        }

        if (list?.description!== undefined && list?.description.length < 60) {
            toast.warning("Description must be minimum 60 words")
            return false
        }

        // console.log("listlistlist "+JSON.stringify(list))
        // return false
        setIsLoading(true)
        await saveActivity(list)
        setIsLoading(false)
    }

    useEffect(() => {
        if(pendingActivity?.data !== null && pendingActivity?.data !== undefined && Object.keys(pendingActivity?.data).length > 0){
            setIsActivityCreated(true)
        }
    }, [pendingActivity])

    return (
        <>
            <SuccessModal
                isOpen={isSuccessModalOpen}
                msg={saveActivityRes?.message}
                url={`valet-activity-list/${match?.params?.opportunity_id}/${match?.params?.account_id}`}
            />

            <FailedModal
                isOpen={isFailedModalOpen}
                msg={saveActivityRes?.message}
                countToOpenModal={countToOpenModal}
            />
            <Loader isLoading={isLoading}/>

            <div id="wrapper">
                <DashboardMenu/>
                <div id="content-wrapper" className="d-flex flex-column">
                    <div id="content">
                        <Header
                            title={"Activity"}
                            history={history}
                        />
                        {/*BODY*/}

                        <div className="container-fluid common-bg">
                            <>
                                <form onSubmit={(e) => handleSubmit(e)}>
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div
                                                className="d-sm-flex align-items-center justify-content-between com-sub-heading">
                                                {/*<h1 className="h3 mb-0 text-black-100">*/}
                                                {/*    <span style={{color: "green"}}>{distance}</span>*/}
                                                {/*</h1>*/}
                                            </div>
                                            <div className="card-body bg-white">
                                                <div className="user">
                                                    <div className="form-group row">
                                                        <div className="col-sm-6 mt-1 float-field"
                                                             style={{marginTop: "16px !important"}}>
                                                            <select
                                                                className="form-control form-control-user"
                                                                onChange={(e) => {
                                                                    handleInput('next_activity_type_id', e.target.value, e)
                                                                    setActivityTypeId(e.target.value)
                                                                }}>
                                                                <option value="">Select Activity</option>
                                                                {activityTypesDetails && activityTypesDetails?.data !== undefined && activityTypesDetails?.data.map((val) => {
                                                                    return (
                                                                        <>
                                                                            {parseInt(activityTypeId) === val?.id ?

                                                                                <option
                                                                                    value={val?.id}
                                                                                    selected={true}>{val.name}
                                                                                </option> :
                                                                                <option
                                                                                    value={val?.id}>{val.name}
                                                                                </option>
                                                                            }
                                                                        </>
                                                                    )
                                                                })}
                                                            </select>
                                                            <label className="large-label float-lb">
                                                                Schedule Activity
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field">
                                                            <input type="datetime-local"
                                                                   className="form-control form-control-user"
                                                                   placeholder=" "
                                                                   onChange={(e) => {
                                                                       handleInput('next_activity_date', e.target.value, e)
                                                                       setCurrentDate(e.target.value)
                                                                   }}
                                                                   my-date-format={"DD/MM/YYYY, HH:mm:ss"}
                                                                   id="validationCustom01"
                                                                   min={new Date().toISOString().split('T')[0] + "T00:00"}
                                                                   value={currentDate}
                                                                   disabled={parseInt(activityTypeId) === 16}
                                                            />
                                                            <label className="large-label float-lb">
                                                                Activity Date
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <DropDownInput
                                                                data={senior}
                                                                label={'Tagged Along'}
                                                                getIdValue={(val) => {
                                                                    setTaggedAlonedReportee(val)
                                                                }}
                                                                multipule={true}
                                                            />
                                                        </div>
                                                        <div className="col-sm-6 mtk-075 float-field mb-4">
                                                            <textarea
                                                                className="form-control form-control-user"
                                                                placeholder=" Description"
                                                                onChange={(e) => {
                                                                    handleInput('description', e.target.value, '', e)
                                                                }}
                                                                id="validationCustom01"
                                                                rows="4" cols="50"
                                                                required={true}
                                                            />
                                                            <label className="large-label float-lb">
                                                                {/*Description*/}
                                                            </label>
                                                        </div>
                                                        <div className="col-sm-12 mtk-1 float-field mb-3 d-mtk-2">
                                                            <FileUpload
                                                                id={"addAttachment"}
                                                                accept=".png,.jpg,.jpeg"
                                                                documentUploadUrl={documentUploadUrlPublic}
                                                                documentUrlData={documentUrlDataPublic}
                                                                onChange={(e, val) => {
                                                                    handleInput('meta_data', e, 'Document', e)
                                                                }}
                                                                prefilledFilename={""}
                                                                multiple={true}
                                                            >
                                                                File Attachment
                                                            </FileUpload>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            {/*</div>*/}
                                            <div className="col-md-12 mt-4 d-flex">
                                                <button className="btn btn-primary btn-user btn-block submit-btn">
                                                    Submit
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ValetActivitySave

